<template>
  <div class="volumes">
    <i class="fa fa-chevron-right"
       style="font-size: 18px"
       @click="open"
    />
    <el-dialog title="Выбрать профессию" :visible.sync="isSelect" append-to-body
               width="400px">
      <div class="jobs-ul">
        <div
          class="jobs-li" v-for="(job, index) in list" :key="index" @click="add(job)"
        >
          <span>{{ job.name }}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="Отчет по числености"
      append-to-body
      width="400px" :visible.sync="dialogObject">
      <div class="volumes">

        <div class="jobs-ul">
          <el-button size="small" class="add" type="primary" style="width: 100%; margin-bottom: 10px"
                     @click="isSelect = !isSelect">
            + Выбрать {{ tr[type] }}
          </el-button>
          <div style="display: flex; justify-content: flex-start">
          </div>
          <div class="jobs-li" v-for="(job, index) in result" :key="index">
            <div style="display: flex; justify-content: space-between; flex: 1; width: 100%">
              <div>
                <div class="flex" style="justify-content: flex-start; margin-bottom: 2px">
                  <strong>{{ job.name || job.label || (job.job && job.job.name) }}</strong>
                </div>
              </div>

              <div class="flex align">
                <div>
                </div>
                <i class="el-icon-close" style="margin-left: 10px" @click="remove(index)"/>
              </div>
            </div>
            <el-row>

              <el-col :span="12">
                <el-input size="small" placeholder="Чел" type="number" v-model="job.value"/>
              </el-col>
              <el-col v-if="$store.state.project.available_reports.PROF_TIME" :span="12">
                <el-input size="small" placeholder="Часы" type="number" v-model="job.time"/>
              </el-col>
            </el-row>
          </div>
          <filter-select label="Вид работы" style="margin-bottom: 0; margin-top: 12px" :options="workTypeOptions"
                         v-model="form.work_type"/>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
        <el-button type="danger" v-if="result.length" @click="removeAll">Удалить</el-button>

        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import firebase from "firebase";
import {getCurrentMonth} from "../../../../utils/date";
import FilterSelect from "../../../../components/FilterSelect";
import {toFloat} from "../../../../utils/numberUtils";

export default {
  name: "AddProfTechToJob",
  components: {FilterSelect},
  props: {
    mainForm: [Array, Object],
    jobs: Array,
    workTypeOptions: {type: [Object, Array], default: () => ([])},
    jobName: "",
    table: {type: [Object, Array], default: () => ([])},
    type: String,
  },
  data() {
    return {
      dialogObject: false,
      isSelect: false,
      result: [],
      list: [],
      form: {
        work_type: null
      },
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        if (table && table.jobs) {
          this.result = [
            ...table.jobs
          ]
        }
      }
    }
  },
  methods: {
    open() {
      this.dialogObject = true
      if(this.mainForm && this.mainForm.work_type && this.mainForm.work_type.value) {
        this.form.work_type = this.mainForm.work_type
      }
    },
    add(job) {
      this.result.push({
        ...job._data,
        plan: job._data.plan || '',
        value: '',
        time: '',
      });
      this.isSelect = false;
    },
    removeAll() {
      this.result = []
    },
    save() {
      this.$emit('save', {
        jobs: [
          ...this.result,
        ],
        total: toFloat(this.total),
        value: toFloat(this.value),
        time: toFloat(this.time)
      })

      this.dialogObject = false;
    },
    remove(index) {
      const result = [...this.result];
      result.splice(index, 1)
      this.result = [...result];
    }
  },
  mounted() {
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
            _data: data
          })
        })

        if( !this.result.length && this.type === 'PROF') {
          const worker = result.find((j) => j.name === 'Рабочие')
          if (worker) {
            this.add(worker)
          }
        }

        this.list = result;
      });
  },
  computed: {
    total() {
      let result = 0;

      this.result.forEach(({plan}) => {
        result += plan || 0
      })

      return result
    },
    value() {
      let result = 0;

      this.result.forEach(({value}) => {
        result += value || 0
      })

      return result
    },
    time() {
      let result = 0;

      this.result.forEach(({time}) => {
        result += time || 0
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">
.fa-edit {
  font-size: 18px;
  width: 100px;
}
.volumes {
  max-width: 95%;
  margin-left: 8px;
}

.create-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: center;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  text-align: left;
  align-items: flex-start;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    padding-bottom: 8px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}

input::placeholder {
  color: #888 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/components/AddProfTechToJob.vue